export const noProviderError = (hookOrHOC: string): string => `${hookOrHOC} can only be used inside <StytchProvider>.`;

export const lazyError = (hookOrHOC: string): string =>
  `${hookOrHOC} can only be used if Stytch is preloaded. Add <script src="https://js.stytch.com/stytch.js" /> in your document header to load the script synchronously, or use ${hookOrHOC}Lazy if you want to lazy load Stytch. If you are using SSR, you will need to use ${hookOrHOC}Lazy.`;
